'use client';
import { defineClientConfig } from 'fumadocs-openapi/ui/client';

export default defineClientConfig({
  // Client-side configuration
  // e.g. you can add custom media adapters
});
